// Errors
export const GET_ERRORS = 'GET_ERRORS'
export const CLEAR_ERRORS = 'CLEAR_ERRORS'
export const CLEAR_ERROR_ON_HANDLE_CHANGE = 'CLEAR_ERROR_ON_HANDLE_CHANGE'
export const GET_CUSTOM_ERRORS = 'GET_CUSTOM_ERRORS'
